import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useTheme, Box, Typography, Chip, Card, CardContent } from '@mui/material';

const TYPE_COLOR = { CREW: 'primary', 'NON-CREW': 'default' };

const RecentAdditions = ({ employees }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>Recent Additions</Typography>
        {employees.map(emp => (
          <Box
            key={emp._id}
            display="flex" alignItems="center" gap={1.5} py={0.75} px={1}
            sx={{
              borderBottom: `1px solid ${theme.palette.divider}`,
              cursor: 'pointer', borderRadius: 1,
              '&:hover': { bgcolor: 'action.hover' },
            }}
            onClick={() => navigate(`/employees/${emp._id}`)}
          >
            <Box sx={{
              width: 32, height: 32, borderRadius: '50%',
              bgcolor: 'primary.main', display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: 'primary.contrastText',
              fontWeight: 'bold', fontSize: 13, flexShrink: 0,
            }}>
              {emp.employeeName?.charAt(0) || '?'}
            </Box>
            <Box flex={1} minWidth={0}>
              <Typography variant="body2" fontWeight="500" noWrap>{emp.employeeName}</Typography>
              <Typography variant="caption" color="text.secondary">{emp.employeeCode}</Typography>
            </Box>
            <Chip
              label={emp.employeeType || 'NON-CREW'}
              color={TYPE_COLOR[emp.employeeType] || 'default'}
              size="small"
            />
            {emp.createdAt && (
              <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                {format(new Date(emp.createdAt), 'dd/MM/yyyy')}
              </Typography>
            )}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default RecentAdditions;
